import supportTypeEnum from '../supportTypeEnum'

export default function teamValidator(donationFor, donationTeam) {
  return donationFor === supportTypeEnum.STAFET || donationTeam !== ''
}